import { ThemeConfig } from 'antd/lib';

export const theme: ThemeConfig = {
  token: {
    borderRadius: 8,
    colorPrimary: '#ffd014',
    colorPrimaryHover: '#ffdb33',
    colorPrimaryActive: '#e6bb12',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f8f9fa',
    colorBgSpotlight: '#ffffff',
    colorBorder: '#dee2e6',
    colorBorderSecondary: '#e9ecef',
    colorFill: '#f8f9fa',
    colorFillSecondary: '#e9ecef',
    colorFillTertiary: '#f8f9fa',
    colorFillQuaternary: '#ffffff',
    colorText: '#212529',
    colorTextSecondary: '#6c757d',
    colorTextTertiary: '#adb5bd',
    colorTextQuaternary: '#6c757d',
    colorTextPlaceholder: '#adb5bd',
    colorTextDisabled: '#adb5bd',
    colorTextHeading: '#212529',
    colorSuccess: '#28a745',
    colorWarning: '#ffc107',
    colorError: '#dc3545',
    colorInfo: '#17a2b8',
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    lineHeight: 1.5714,
    lineHeightHeading1: 1.2105,
    lineHeightHeading2: 1.2667,
    lineHeightHeading3: 1.3333,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.5,
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    controlHeightXS: 24,
    padding: 16,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    paddingXL: 32,
    margin: 16,
    marginXS: 8,
    marginSM: 12,
    marginLG: 24,
    marginXL: 32,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
    boxShadowSecondary: '0 1px 4px rgba(0, 0, 0, 0.1)',
  },
  components: {
    Layout: {
      headerHeight: 64,
      headerBg: '#000000',
      headerColor: '#ffffff',
      siderBg: '#1a1a1a',
      bodyBg: '#f8f9fa',
      footerBg: '#ffffff',
      footerPadding: '16px 24px',
    },
    Menu: {
      itemBg: '#1a1a1a',
      itemHoverBg: '#2a2a2a',
      itemSelectedBg: '#ffd014',
      itemSelectedColor: '#000000',
      itemColor: '#ffffff',
      subMenuItemBg: '#1a1a1a',
      darkItemBg: '#1a1a1a',
      darkItemHoverBg: '#2a2a2a',
      darkItemSelectedBg: '#ffd014',
      darkItemSelectedColor: '#000000',
      darkItemColor: '#ffffff',
      darkSubMenuItemBg: '#1a1a1a',
      itemMarginInline: 8,
      itemBorderRadius: 6,
      itemHoverColor: '#ffffff',
    },
    Button: {
      controlHeight: 40,
      borderRadius: 8,
      colorPrimary: '#ffd014',
      colorPrimaryHover: '#ffdb33',
      colorPrimaryActive: '#e6bb12',
      colorBgContainer: '#ffffff',
      colorBorder: '#dee2e6',
      colorText: '#212529',
    },
    Table: {
      colorBgContainer: '#ffffff',
      colorFillAlter: '#f8f9fa',
      colorFillContent: '#ffffff',
      colorFillSecondary: '#e9ecef',
      colorBorderSecondary: '#e9ecef',
      colorText: '#212529',
      colorTextHeading: '#212529',
      headerBg: '#ffffff',
      headerColor: '#212529',
      rowHoverBg: '#f8f9fa',
    },
    Modal: {
      colorBgElevated: '#ffffff',
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
      colorText: '#212529',
      colorTextHeading: '#212529',
      borderRadius: 12,
    },
    Form: {
      colorText: '#212529',
      colorTextHeading: '#212529',
      colorTextDescription: '#6c757d',
      colorBorder: '#dee2e6',
    },
    Input: {
      colorBgContainer: '#ffffff',
      colorBorder: '#dee2e6',
      colorText: '#212529',
      colorTextPlaceholder: '#adb5bd',
      borderRadius: 8,
    },
    Select: {
      colorBgContainer: '#ffffff',
      colorBorder: '#dee2e6',
      colorText: '#212529',
      colorTextPlaceholder: '#adb5bd',
      borderRadius: 8,
    },
    Typography: {
      colorText: '#212529',
      colorTextHeading: '#212529',
      colorTextDescription: '#6c757d',
    },
    Card: {
      colorBgContainer: '#ffffff',
      colorBorderSecondary: '#e9ecef',
      colorText: '#212529',
      colorTextHeading: '#212529',
      borderRadius: 12,
    },
    Tag: {
      colorBgContainer: '#f8f9fa',
      colorBorder: '#dee2e6',
      colorText: '#212529',
      borderRadius: 6,
    },
  },
};
